var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMtAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1.5 16c-.82739256 0-1.5-.6733398-1.5-1.5v-13c0-.82666016.67260744-1.5 1.5-1.5h13c.8273926 0 1.5.67333984 1.5 1.5v13c0 .8266602-.6726074 1.5-1.5 1.5zm6-7.5h-6.5v6c0 .2753906.22399903.5.5.5h6zm7.5 0h-6.5v6.5h6c.276001 0 .5-.2246094.5-.5zm-7.5-7.5h-6c-.27600097 0-.5.22460938-.5.5v6h6.5zm7 0h-6v6.5h6.5v-6c0-.27539062-.223999-.5-.5-.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtAll);
export default __webpack_public_path__ + "static/media/mt-all.d4c8c14ae5834d1be41b109a6a8425ba.svg";
export { ForwardRef as ReactComponent };